<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <el-form class="query-form" label-position="right" label-width="40px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="品牌">
                <BrandSelect :data="brandList" v-model="queryForm.brandId" filterable clearable></BrandSelect>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button @click="search" type="primary">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>

    <div>
      <el-button @click="showForm" type="primary" icon="el-icon-circle-plus-outline">上传质检标准</el-button>
    </div>

    <el-table :data="tableData" v-loading="loading">
      <el-table-column prop="updatedAt" label="日期">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column prop="brandName" label="品牌"></el-table-column>
      <el-table-column prop="l2CategoryIdsName" label="品类"></el-table-column>
      <el-table-column prop="action" label="图片预览/编辑">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="remove" label="删除">
        <template slot-scope="scope">
          <el-link type="primary" @click="removeItem(scope.row)">删除</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="updateBy" label="操作人"></el-table-column>
      <el-table-column prop="updatedAt" label="更新时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.updatedAt) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="form.sellerQcStandardId ? '编辑' : '新增'" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="80px" v-loading="formLoading">
        <el-form-item label="品牌" prop="brandId" :rules="[{ required: true, message: '请选择品牌' }]">
          <BrandSelect :data="brandList" v-model="form.brandId" filterable clearable></BrandSelect>
        </el-form-item>
        <el-form-item label="品类" prop="l2CategoryIds" :rules="[{ required: true, message: '请选择品类' }]">
          <el-cascader v-model="form.l2CategoryIds" :options="categoryList" :props="optionProps" clearable :style="{width: '100%'}"></el-cascader>
        </el-form-item>
        <el-form-item label="质检图片" prop="image" :rules="[{ required: true, message: '请上传图片' }]">
          <div class="mb10">
            <el-button type="text" v-if="form.image" @click="showLargeImg">查看大图</el-button>
          </div>
          <div class="upload-btn">
            <img v-if="form.image" class="qa-img" :src="form.image" alt="">
            <el-button v-else type="primary" icon="el-icon-upload" plain>点击上传</el-button>
            <input @change="changeFile" accept=".png,.jpg.jpeg" type="file" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Client from "@/utils/client.js";
import utils from '@/utils/util';
import {
  getBrandList,
  getCategory,
  getQCStandardList,
  createQCStandard,
  updateQCStandard,
  deleteQCStandard,
  getQCStandard,
} from "./api";
import { fileUpload } from '../../api/merchants';
import BrandSelect from '../shared/brandSelect.vue';

export default {
  components: {
    BrandSelect,
  },
  data() {
    return {
      fullscreenLoading: false,
      brandList: [],
      categoryList: [],
      queryForm: {
        brandId: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      loading: false,
      optionProps: {
        value: 'categoryId',
        children: 'children',
        label: 'chineseName',
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      },
      dialogVisible: false,
      form: {
        sellerQcStandardId: null,
        brandId: null,
        l2CategoryIds: [],
        image: null,
      },
      formLoading: false,
    };
  },
  created() {
    getBrandList().then(res => {//获取品牌列表
      this.brandList = (res.data || []).map(item => {
        return {
          label: item.englishName,
          value: item.brandId
        };
      });
    });
    getCategory().then(res => {
      this.categoryList = (res.data || []).map(item => {
        return {
          ...item,
          children: item.children.map(item2 => {
            return {
              categoryId: item2.categoryId,
              chineseName: item2.chineseName,
            }
          })
        };
      });
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.processResult = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getQCStandardList(this.queryForm).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
        this.loading = false;
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    async changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.(png|jpe?g)(\?.*)?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.jpg .jpeg .png格式');
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件太大了');
          return;
        }
        this.fullscreenLoading = true;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const objectKey = `tmp/${new Date().getTime()}${Math.random()}.${file.name.split('.').pop()}`;
        const res = await OSSClient.put(objectKey, file);
        this.form.image = res.url;
        this.fullscreenLoading = false;
      }
      e.target.value = '';
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    showForm() { 
      this.form.sellerQcStandardId = null;
      this.form.brandId = null;
      this.form.l2CategoryIds = [];
      this.form.image = null;
      this.formLoading = false;
      this.dialogVisible = true;
      this.$nextTick(() => { 
        this.$refs.form.clearValidate();
      });
    },
    editItem(row) {
      this.form.sellerQcStandardId = row.sellerQcStandardId;
      this.form.brandId = null;
      this.form.l2CategoryIds = [];
      this.form.image = null;
      this.formLoading = true;
      getQCStandard(this.form.sellerQcStandardId).then(res => {
        if (res.data && res.data.success) {
          this.form.brandId = res.data.data.brandId;
          this.form.l2CategoryIds = res.data.data.l2CategoryIds || [];
          this.form.image = res.data.data.image;
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
        this.formLoading = false;
      })
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let request = createQCStandard;
          if (this.form.sellerQcStandardId) {
            request = updateQCStandard;
          }
          if (this.repeatSubmit) {
            return;
          }
          this.repeatSubmit = true;
          request(this.form).then(res => {
            if (res.data && res.data.success) {
              this.$message.success('提交成功');
              this.dialogVisible = false;
              this.getTableData();
            } else {
              this.$message.error(res.data.message || '系统异常，请稍后再试');
            }
            setTimeout(() => {
              this.repeatSubmit = false;
            }, 2000);
          }).catch(() => {
            setTimeout(() => {
              this.repeatSubmit = false;
            }, 2000);
          })
        }
      })
    },
    removeItem(row) {
      this.$confirm(`确认删除吗？`, '确认', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        deleteQCStandard(row.sellerQcStandardId).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success('删除成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
        });
      }).catch(() => {});
    },
    showLargeImg() {
      window.open(this.form.image)
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.upload-btn {
  position: relative;
  display: inline-block;
  margin-right: 50px;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
.qa-img {
  display: block;
  max-width: 400px;
  max-height: 400px;
}
</style>
